var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReferralUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m16,3c0-1.654,1.346-3,3-3s3,1.346,3,3-1.346,3-3,3-3-1.346-3-3Zm0,13c0,1.654,1.346,3,3,3s3-1.346,3-3-1.346-3-3-3-3,1.346-3,3Zm3,4c-2.15,0-4.009,1.132-4.905,2.779-.305.561.159,1.221.844,1.221h8.121c.685,0,1.149-.66.844-1.221-.895-1.647-2.755-2.779-4.905-2.779Zm-4.06-9h8.121c.685,0,1.149-.66.844-1.221-.895-1.647-2.755-2.779-4.905-2.779s-4.009,1.132-4.905,2.779c-.305.561.159,1.221.844,1.221Zm-4.668,3.55c-.472-.466-1.271-.131-1.271.531v1.919h-3.5c-1.379,0-2.5-1.121-2.5-2.5v-5c0-1.379,1.121-2.5,2.5-2.5h5c.828,0,1.5-.672,1.5-1.5s-.672-1.5-1.5-1.5h-5C2.468,4,0,6.468,0,9.5v5c0,3.032,2.468,5.5,5.5,5.5h3.5v1.919c0,.663.8.997,1.271.531l3.536-3.49c.256-.253.256-.667,0-.92l-3.536-3.49Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReferralUser);
export default __webpack_public_path__ + "static/media/referral-user.28a114d2639af111b5e49e36a1327b93.svg";
export { ForwardRef as ReactComponent };